import React, { memo } from 'react';
import { ResidenceSection } from '../ResidenceSection';
import { ResidenceSpecialOffer } from '../../../../graphql/graphql';
import {
  AdditionalInfoContainer,
  AdditionalInfoItem,
  InfoContainer,
  InfoDescription
} from './styled';
import { Typography } from '../../../ui/Typography';

interface AdditionalInfoSectionProps {
  offers: ResidenceSpecialOffer[];
}

export const AdditionalInfoSection: React.FC<AdditionalInfoSectionProps> = memo(
  ({ offers }) => (
    <ResidenceSection>
      <AdditionalInfoContainer data-cy="residence-offers-section">
        {offers?.map((offer, index) => (
          <AdditionalInfoItem
            key={index}
            $offerType={offer.offerType}
            data-cy="residence-offer"
          >
            <InfoContainer>
              <Typography tag="title_4_new" data-cy="residence-offer-title">
                {offer.name}
              </Typography>
              <InfoDescription tag="body_2" data-cy="residence-offer-value">
                {offer.description}
              </InfoDescription>
            </InfoContainer>
          </AdditionalInfoItem>
        ))}
      </AdditionalInfoContainer>
    </ResidenceSection>
  )
);

AdditionalInfoSection.displayName = `AdditionalInfoSection`;
